/*
 * @Author: Teemo Ding
 * @Date: 2021-11-03 16:36:17
 * @LastEditTime: 2021-11-05 16:19:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/InternalRemark/index.tsx
 */
import React from 'react';
import { Form } from 'antd';
import { ModalFooter, TextArea, Label } from '@/src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const InternalRemark = ({ onCancel, onOk, initValue }) => {
  const [form] = Form.useForm();
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  return (
    <div>
      <Form
        name='internalRemark'
        initialValues={{ remark: initValue }}
        labelCol={{ span: 24 }}
        form={form}
        onFinish={onOk}
        className={css.internalRemark}>
        <Form.Item
          label={
            <Label
              title={getI18n(
                'allOrders.orderDetail.component_customer_return_Internal_remarkitem',
              )}
              textLength={500}
              nameKey={'remark'}
            />
          }
          name='remark'
          labelCol={{ span: 24 }}>
          <TextArea size='large' maxLength={500} />
        </Form.Item>
      </Form>

      <ModalFooter
        onOk={() => form.submit()}
        onCancel={() => onCancel()}
        okText={getI18n('general.confirm')}
      />
    </div>
  );
};

export default InternalRemark;
